import React from 'react';
import './Footer.css';

const Footer = () => {
 return (
  <footer className='footer'>
   <div className='container'>
    <div className='footer-content'>
     <div className='footer-section'>
      <h3>Vi Le CPA, PLLC</h3>
      <p>
       Premier accounting firm offering professional, personalized services to
       clients in the Puget Sound area.
      </p>
      <div className='footer-contact'>
       <p>📍 707 S Grady Way Suite 600, Renton, WA 98057</p>
       <p>
        📞{' '}
        <a href='tel:206-377-9501' style={{ color: '#7b92a9' }}>
         206-377-9501
        </a>
       </p>
      </div>
     </div>

     <div className='footer-section'>
      <h4>Services</h4>
      <ul>
       <li>Tax Management</li>
       <li>Accounting Services</li>
       <li>Financial Planning</li>
       <li>Bookkeeping</li>
       <li>Business Valuations</li>
       <li>Debt & Finance Advising</li>
      </ul>
     </div>

     <div className='footer-section'>
      <h4>Quick Links</h4>
      <ul>
       <li>
        <a href='#home'>Home</a>
       </li>
       <li>
        <a href='#services'>Services</a>
       </li>
       <li>
        <a href='#about'>About</a>
       </li>
       <li>
        <a href='#contact'>Contact</a>
       </li>
      </ul>
     </div>

    </div>

    <div className='footer-bottom'>
     <div className='footer-bottom-content'>
      <p>&copy; 2024 Vi Le CPA, PLLC. All rights reserved.</p>
      <p>Professional accounting services for the Puget Sound area</p>
     </div>
    </div>
   </div>
  </footer>
 );
};

export default Footer;
